
import socketIOClient from "socket.io-client";
const HOST = process.env.NODE_ENV === 'production' ? null : "http://0.0.0.0:8080";

export const socket = socketIOClient(HOST);

export function openGameLobby(game) {
	return dispatch => {
		dispatch({ type: "OPEN_GAME_LOBBY", game: game });
	}
}

export function joinGame(playerName, gameName, gamePassword, create=false) {
	return dispatch => {
		var event = create ? "create game" : "join game";

		socket.emit(event, {
	      playerName, 
	      gameName,
	      gamePassword,
	    }, (success, data) => {
			if (success) {
				localStorage.setItem('playerKey', data.key);
				localStorage.setItem('gameName', data.game_name);
			    dispatch({ 
			    	type: "ACCESS_GRANTED", 
			    	playerName: data.name,
			    	playerID: data.id,
			    	game: {
			    		gameName: data.game_name
			    	}
			    });
			} else {
				dispatch({ type: "SERVER_ERROR", serverError: data.message });
			}
	    });
	}
}

export function rejoinGame(playerKey, gameName, onError) {
	return dispatch => {
		socket.emit("rejoin game", {
	      playerKey,
	      gameName
	    }, (success, data) => {
			if (success) {
			    dispatch({ 
			    	type: "ACCESS_GRANTED", 
			    	playerName: data.name,
			    	playerID: data.id,
			    	game: {
			    		gameName: data.game_name
			    	}
			    });
			} else {
				onError();
				dispatch({ type: "ACCESS_DENIED", serverError: data.message });
			}
	    });
	}
}

export function leaveGame() {
	return dispatch => {
		localStorage.clear();
		socket.emit("leave game", (success) => {
			if (success) {
				dispatch({ 
			    	type: "LEAVE_GAME"
			    });
			} else {
				console.log("Error leaving game.")
			}
		});
		
	}
}

export function resetGame() {
	return dispatch => {
		// localStorage.clear();
		dispatch({ 
	    	type: "RESET_GAME"
	    });
	}
}


export function updateGame(data) {
	return dispatch => {
		dispatch({ 
	    	type: "UPDATE_GAME",
	    	data,
	    });
	}
}

export function setPeekCards(cards) {
	return dispatch => {
		dispatch({ 
	    	type: "SET_PEEK_CARDS",
	    	cards,
	    });
	}
}

export function updateLawChoices(laws) {
	return dispatch => {
		dispatch({ 
	    	type: "UPDATE_LAW_CHOICES",
	    	laws,
	    });
	}
}

export function updatePlayers(data) {
	return dispatch => {
		dispatch({ type: "PLAYERS_UPDATED", players: data });
	}
}

export function updateGamesList(data) {
	return dispatch => {
		dispatch({ type: "GAMES_LIST_UPDATED", games: data });
	}
}

var votesTimeout = null;
export function updateVotes(data) {
	return dispatch => {
		window.clearTimeout(votesTimeout);

		dispatch({ 
			type: "UPDATE_VOTES", 
			votes: data
		});

		votesTimeout = window.setTimeout(() => { 
			dispatch({ 
				type: "UPDATE_VOTES", 
				votes: undefined
			});
		 }, 3000);
	}
}

export function startGame(data) {
	return dispatch => {
		dispatch({ 
			type: "START_GAME", 
			role: data.role, 
			title: data.title
		});
	}
}


var investigationTimeout = null;
export function playerInvestigated(data) {
	window.clearTimeout(investigationTimeout);

	return dispatch => {
		dispatch({ 
			type: "PLAYER_INVESTIGATED", 
			player: data
		});

		investigationTimeout = window.setTimeout(() => { 
			dispatch({ 
				type: "PLAYER_INVESTIGATED", 
				votes: undefined
			});
		}, 3000);
	}
}


export function nominateChancellor(playerID) {
	return dispatch => {
		socket.emit("nominate chancellor", playerID);
	}
}

var transitionTimeout = null;
export function setTransition(message) {
	
	return dispatch => {
		window.clearTimeout(transitionTimeout);

		dispatch({ 
			type: "SET_TRANSITION", 
			message: message
		});

		transitionTimeout = window.setTimeout(() => { 
			dispatch({ 
				type: "SET_TRANSITION", 
				message: undefined
			});
		 }, 3000);   
	}
	
}